export default __webpack_public_path__ + "static/media/arrow_outward.baa31ef9.svg";